import { type SettingsStore } from "../stores/settings";
import Cookie from "js-cookie";

export type Consent = {
  essential: boolean;
  analytics_storage: boolean;
  functionality_storage: boolean;
  ad_storage: boolean;
};

const timeout = 31104000000; // 12 months in milliseconds

const setupConsent = (config: Record<string, string>) => {
  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push(config);
  window.dataLayer.push({ event: "update-consent" });
  window.dataLayer.push({ event: "refresh-consent-tags" });
};

const defaultConfig = {
  analytics_storage: "granted",
  functionality_storage: "granted"
};

export const accept = (config = defaultConfig) => {
  setCookie("hasConsent", "true");
  setupConsent(config);
};

export const deny = () => {
  setCookie("hasConsent", "false");
};

const setCookie = (name: string, value: string) => {
  const date = new Date(new Date().getTime() + timeout);
  Cookie.set(name, value, { expires: date, path: "/", secure: true, sameSite: "lax" });
};

export const checkVisibility = (settingsStore: SettingsStore) => {
  const enableEUCookieBanner = settingsStore.enableEUCookieBanner;
  const hasConsent = Boolean(Cookie.get("hasConsent"));
  const isBot = /bot|crawler|spider|crawling/i.test(navigator.userAgent);
  return enableEUCookieBanner && !isBot && !hasConsent;
};

export const savePreferences = (consent: Consent) => {
  console.log("Saving preferences", consent);
  const entries = Object.entries(consent) as [keyof Consent, boolean][];
  const config = entries.reduce((acc, [key, value]) => {
    acc[key] = value ? "granted" : "denied";
    return acc;
  }, {} as Record<keyof Consent, string>);
  accept(config);
};
